import { render, staticRenderFns } from "./countries.vue?vue&type=template&id=9983ad42"
import script from "./countries.vue?vue&type=script&lang=js"
export * from "./countries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports